<div class="app-sidebar__overlay" (click)="INDRA_handleOverlayClick()">
	<app-loading *ngIf="showLoading" ></app-loading>
</div>
<div  class="app-sidebar__content" #sidebar id="sidebar" role="dialog" aria-modal="true" aria-labelledby="sidebar__title" tabindex="0" *ngIf="!showLoading">
	<ng-content #sidebar__content></ng-content>
</div>
